import React, { createContext, useState, useEffect, useContext } from 'react';

const ProjectContext = createContext();
const API_BASE = '/api';

export function ProjectProvider({ children }) {
  const [currentProject, setCurrentProject] = useState(null);
  const [availableProjects, setAvailableProjects] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchProjects();
  }, []);

  const fetchProjects = async () => {
    try {
      const response = await fetch(`${API_BASE}/projects.php`, {
        credentials: 'include'
      });
      const data = await response.json();
      setAvailableProjects(data.projects || []);
      setCurrentProject(data.current_project || null);
    } catch (error) {
      console.error('Failed to fetch projects:', error);
    } finally {
      setLoading(false);
    }
  };

  const switchProject = async (projectId) => {
    try {
      const response = await fetch(`${API_BASE}/projects.php`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ project_id: projectId })
      });
      const data = await response.json();
      if (data.success) {
        setCurrentProject(projectId);
        return true;
      }
      return false;
    } catch (error) {
      console.error('Failed to switch project:', error);
      return false;
    }
  };

  return (
    <ProjectContext.Provider value={{
      currentProject,
      availableProjects,
      switchProject,
      loading
    }}>
      {children}
    </ProjectContext.Provider>
  );
}

export const useProject = () => useContext(ProjectContext);